import {
  ConfigDataParser as SERVICE_WORKER_ConfigDataParser,
  NavTabPath as SERVICE_WORKER_NavTabPath,
  PagePath as SERVICE_WORKER_PagePath,
  SectionPath as SERVICE_WORKER_SectionPath,
  QuestionPath as SERVICE_WORKER_QuestionPath,
} from '../../../../ServiceWorker/src/helpers/config-data-parser';

export { SERVICE_WORKER_ConfigDataParser as ConfigDataParser };
export { SERVICE_WORKER_NavTabPath as NavTabPath };
export { SERVICE_WORKER_PagePath as PagePath };
export { SERVICE_WORKER_SectionPath as SectionPath };
export { SERVICE_WORKER_QuestionPath as QuestionPath };
